import React from 'react'
import styled from 'styled-components'
import Error from './Utils/Error'
import Spinner from './Utils/Spinner'
import MediaQuery from 'react-responsive'
import { FlexRow } from './Utils/CustomClassesV2'
import { strLimit } from '../utils/utils'
import { decode } from 'html-entities'
import {
  ActionButtons,
  ContainerFlexRow,
  ContainerFlexColumn,
  ContainerFlexColumnStart,
  CustomSubtitle,
  Image,
  Input,
} from './Utils/CustomClasses'

const Container = styled.div`
  background-color: #fff;
  margin-top: 40px;

  @media screen and (max-width: 980px) {
    margin-top: 120px;
  }

  @media screen and (max-width: 768px) {
    margin-top: 65px;
  }

  @media screen and (max-width: 767px) {
    margin-top: -15px;
  }
`

const Section = styled.div`
  padding: 74px 8vw 74px 8vw;
  ${({ backgoundColor }) =>
    backgoundColor && `background-color: ${backgoundColor};`}

  @media only screen and (max-width: 1024px) {
    padding: 74px 7vw 74px 7vw;
  }

  @media only screen and (max-width: 980px) {
    padding: 48px 5vw 60px 5vw;
  }

  @media only screen and (max-width: 600px) {
    padding: 48px 8vw 60px 8vw !important;
  }
`

const Form = styled.form`
  text-align: left;
  width: 40vw;
  min-width: 400px;

  @media screen and (max-width: 768px) {
    width: -webkit-fill-available !important;
    min-width: unset !important;
  }
`

const SubmitButton = styled(ActionButtons)`
  margin-top: 30px;
  width: -webkit-fill-available;
  justify-content: center;
`

const MemberMatchTest = () => {
  const [memberId, setMemberId] = React.useState('')
  const [memberIdError, setMemberIdError] = React.useState(false)
  const [error, setError] = React.useState({})
  const [loading, setLoading] = React.useState(false)
  const [result, setResult] = React.useState({})

  React.useEffect(() => {
    setMemberId(24146)
  }, [])

  const updateMemberId = (e) => {
    setMemberIdError(false)
    setError(null)
    setMemberId(e)
  }

  const SubmitForm = (e) => {
    e.preventDefault()
    setError({})
    setMemberIdError(false)

    if (!memberId) {
      setMemberIdError(true)
      setError('Please add a member ID')
      return
    }

    let isNumber = /^\d+$/.test(memberId)
    if (!isNumber) {
      setMemberIdError(true)
      setError('Member ID must contain only numbers')
      return
    }

    setLoading(true)

    let member = {
      memberId: memberId,
    }

    axios
      .post('/api/search/member-recommender-test', member)
      .then((response) => {
        console.log('response: ' + JSON.stringify(response))
        setResult(response)
      })
      .catch((err) => {
        setError(err)
        setLoading(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const ResultPanel = ({
    content,
    panelHeader,
    index,
    total,
    matchArr,
    matchType,
  }) => {
    var locationStr = ''
    if (content['city_location'] == null) {
      locationStr = 'N/A'
    } else {
      locationStr =
        content['city_location']['city'] + ', ' + content['country']['nicename']
    }

    if (
      matchType == 'location' &&
      locationStr != null &&
      matchArr != undefined &&
      matchArr.length != 0
    ) {
      matchArr.map((item) => {
        if (locationStr.toLowerCase().includes(item.toLowerCase())) {
          locationStr = locationStr
            .toLowerCase()
            .replace(
              item.toLowerCase(),
              '<span style=background-color:#FFFF00>' + item + '</span>'
            )
        }
      })
    }

    var interestStr = content['interest']
    if (
      matchType == 'interests' &&
      interestStr != null &&
      matchArr != undefined &&
      matchArr.length != 0
    ) {
      matchArr.map((item) => {
        if (interestStr.toLowerCase().includes(item.toLowerCase())) {
          interestStr = interestStr
            .toLowerCase()
            .replace(
              item.toLowerCase(),
              '<span style=background-color:#FFFF00>' + item + '</span>'
            )
        }
      })
    }

    var favoVisitedPlaceStr = content['favoVisitedPlace']
    if (
      matchType == 'visited' &&
      favoVisitedPlaceStr != null &&
      matchArr != undefined &&
      matchArr.length != 0
    ) {
      matchArr.map((item) => {
        if (favoVisitedPlaceStr.toLowerCase().includes(item.toLowerCase())) {
          favoVisitedPlaceStr = favoVisitedPlaceStr
            .toLowerCase()
            .replace(
              item.toLowerCase(),
              '<span style=background-color:#FFFF00>' + item + '</span>'
            )
        }
      })
    }

    var favoPlaceStr = content['favoPlace']
    if (
      matchType == 'wanted' &&
      favoPlaceStr != null &&
      matchArr != undefined &&
      matchArr.length != 0
    ) {
      matchArr.map((item) => {
        if (favoPlaceStr.toLowerCase().includes(item.toLowerCase())) {
          favoPlaceStr = favoPlaceStr
            .toLowerCase()
            .replace(
              item.toLowerCase(),
              '<span style=background-color:#FFFF00>' + item + '</span>'
            )
        }
      })
    }

    return (
      <Section>
        {panelHeader.length > 0 && (
          <CustomSubtitle
            bold
            size="30px"
            dangerouslySetInnerHTML={{
              __html: panelHeader,
            }}
          ></CustomSubtitle>
        )}
        <ContainerFlexRow
          gray
          gap="50px"
          padding="5vh 3vw 5vh 3vw"
          paddingSm="4vh 7vw 6vh 7vw"
          paddingMd="7vh 40px 5vh 6vw"
          gapMd="20px"
        >
          <Image width="20vw" widthSm="40vw">
            <img
              src={s3AwsEndpoint + '/' + content['profilePhotoL']}
              onError={(e) => {
                e.target.onError = null
                e.target.src = '/images/listing/profile-coming-soon.png'
              }}
            />
          </Image>
          <ContainerFlexColumnStart center>
            <CustomSubtitle
              bold
              size="26px"
              dangerouslySetInnerHTML={{
                __html: `${
                  index != 99999
                    ? index +
                      1 +
                      '/' +
                      total +
                      ':  ' +
                      content['forename'] +
                      ' ' +
                      content['surname'] +
                      ' - Member ID: ' +
                      content['id']
                    : content['forename'] +
                      ' ' +
                      content['surname'] +
                      ' - Member ID: ' +
                      content['id']
                }`,
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              size="20px"
              dangerouslySetInnerHTML={{
                __html: content['introduction'],
              }}
            ></CustomSubtitle>
          </ContainerFlexColumnStart>
        </ContainerFlexRow>
        <ContainerFlexRow
          gray
          gap="50px"
          padding="2vh 3vw 2vh 3vw"
          gapMd="20px"
        >
          <ContainerFlexColumnStart center>
            <CustomSubtitle
              bold
              size="22px"
              dangerouslySetInnerHTML={{
                __html: 'Location:',
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              size="20px"
              dangerouslySetInnerHTML={{
                __html: locationStr,
              }}
            ></CustomSubtitle>
          </ContainerFlexColumnStart>
        </ContainerFlexRow>
        <ContainerFlexRow
          gray
          gap="50px"
          padding="2vh 3vw 2vh 3vw"
          gapMd="20px"
        >
          <ContainerFlexColumnStart center>
            <CustomSubtitle
              bold
              size="22px"
              dangerouslySetInnerHTML={{
                __html: 'Interests:',
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              size="20px"
              dangerouslySetInnerHTML={{
                __html: interestStr,
              }}
            ></CustomSubtitle>
          </ContainerFlexColumnStart>
        </ContainerFlexRow>
        <ContainerFlexRow
          gray
          gap="50px"
          padding="2vh 3vw 2vh 3vw"
          gapMd="20px"
        >
          <ContainerFlexColumnStart center>
            <CustomSubtitle
              bold
              size="22px"
              dangerouslySetInnerHTML={{
                __html: 'Favourite Places I Have Visited:',
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              size="20px"
              dangerouslySetInnerHTML={{
                __html: favoVisitedPlaceStr,
              }}
            ></CustomSubtitle>
          </ContainerFlexColumnStart>
        </ContainerFlexRow>
        <ContainerFlexRow
          gray
          gap="50px"
          padding="2vh 3vw 2vh 3vw"
          gapMd="20px"
        >
          <ContainerFlexColumnStart center>
            <CustomSubtitle
              bold
              size="22px"
              dangerouslySetInnerHTML={{
                __html: 'Places I Want To Visit:',
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              size="20px"
              dangerouslySetInnerHTML={{
                __html: favoPlaceStr,
              }}
            ></CustomSubtitle>
          </ContainerFlexColumnStart>
        </ContainerFlexRow>
        <ContainerFlexRow
          gray
          gap="50px"
          padding="2vh 3vw 5vh 3vw"
          gapMd="20px"
        >
          <ContainerFlexColumnStart center>
            <CustomSubtitle
              bold
              size="22px"
              dangerouslySetInnerHTML={{
                __html: 'Philosophy:',
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              size="20px"
              dangerouslySetInnerHTML={{
                __html: content['philosophy'],
              }}
            ></CustomSubtitle>
          </ContainerFlexColumnStart>
        </ContainerFlexRow>
        <ContainerFlexRow
          gray
          gap="50px"
          padding="2vh 3vw 8vh 3vw"
          gapMd="20px"
        >
          <ContainerFlexColumnStart center>
            <CustomSubtitle
              bold
              size="22px"
              dangerouslySetInnerHTML={{
                __html: 'Other Interests:',
              }}
            ></CustomSubtitle>
          </ContainerFlexColumnStart>
          <ContainerFlexColumnStart center>
            <CustomSubtitle
              bold
              size="20px"
              dangerouslySetInnerHTML={{
                __html: 'Favourite Book: ',
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              size="20px"
              dangerouslySetInnerHTML={{
                __html: content['favoBook'],
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              bold
              size="20px"
              margin="20px 0 0"
              dangerouslySetInnerHTML={{
                __html: 'Favourite Actor: ',
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              size="20px"
              dangerouslySetInnerHTML={{
                __html: content['favoActor'],
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              bold
              size="20px"
              margin="20px 0 0"
              dangerouslySetInnerHTML={{
                __html: 'Favourite Film: ',
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              size="20px"
              dangerouslySetInnerHTML={{
                __html: content['favoFilm'],
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              bold
              size="20px"
              margin="20px 0 0"
              dangerouslySetInnerHTML={{
                __html: 'Favourite Food: ',
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              size="20px"
              dangerouslySetInnerHTML={{
                __html: content['favoFood'],
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              bold
              size="20px"
              margin="20px 0 0"
              dangerouslySetInnerHTML={{
                __html: 'Favourite Musician/Band: ',
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              size="20px"
              dangerouslySetInnerHTML={{
                __html: content['favoMusician'],
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              bold
              size="20px"
              margin="20px 0 0"
              dangerouslySetInnerHTML={{
                __html: 'Favourite Sport/Activity: ',
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              size="20px"
              dangerouslySetInnerHTML={{
                __html: content['favoExercise'],
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              bold
              size="20px"
              margin="20px 0 0"
              dangerouslySetInnerHTML={{
                __html: 'Ideal Dinner Guest: ',
              }}
            ></CustomSubtitle>
            <CustomSubtitle
              size="20px"
              dangerouslySetInnerHTML={{
                __html: content['favoHero'],
              }}
            ></CustomSubtitle>
          </ContainerFlexColumnStart>
        </ContainerFlexRow>
      </Section>
    )
  }

  return (
    <Container>
      {loading && <Spinner />}
      <Section>
        <FlexRow>
          <Form>
            {/* Member ID */}
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `Enter Member ID`,
              }}
            />
            <Input
              id="memberId"
              type="text"
              name="memberId"
              className={memberIdError && 'error-border'}
              placeholder="Enter Member ID"
              margin="0"
              required
              value={memberId}
              onChange={(e) => updateMemberId(e.target.value)}
            />

            <SubmitButton
              padding="12px 14px"
              type="submit"
              onClick={(e) => SubmitForm(e)}
            >
              Match Members
            </SubmitButton>

            {error && <Error error={error} />}
          </Form>
        </FlexRow>
      </Section>

      {Object.keys(result).length > 0 && (
        <>
          <ResultPanel
            content={result['data']['member']}
            panelHeader={'You have chosen to find matches for this member:'}
            index={99999}
            matchArr={[]}
            matchType="none"
          />

          {result['data']['match1'] !== null ||
          result['data']['match2'] !== null ||
          result['data']['match3'] !== null ||
          result['data']['match4'] !== null ||
          result['data']['match5'] !== null ||
          result['data']['match6'] !== null ||
          result['data']['match7'] !== null ||
          result['data']['match8'] !== null ? (
            <Section>
              <ContainerFlexRow
                yellow
                gap="50px"
                padding="2vh 3vw 2vh 3vw"
                gapMd="20px"
              >
                <ContainerFlexColumnStart center>
                  <CustomSubtitle
                    bold
                    size="30px"
                    dangerouslySetInnerHTML={{
                      __html: 'Matching Summary:',
                    }}
                  ></CustomSubtitle>
                </ContainerFlexColumnStart>
              </ContainerFlexRow>
              <ContainerFlexRow
                gray
                gap="50px"
                padding="2vh 3vw 2vh 3vw"
                gapMd="20px"
              >
                <ContainerFlexColumnStart center>
                  <CustomSubtitle
                    bold
                    size="22px"
                    dangerouslySetInnerHTML={{
                      __html:
                        'Match 1 : Places I want to visit / Places I want to visit:',
                    }}
                  ></CustomSubtitle>
                  <CustomSubtitle
                    size="20px"
                    dangerouslySetInnerHTML={{
                      __html: `No. of matches = ${
                        result['data']['match1'] !== null
                          ? Object.keys(result['data']['match1']).length
                          : 0
                      }:`,
                    }}
                  ></CustomSubtitle>
                </ContainerFlexColumnStart>
              </ContainerFlexRow>
              <ContainerFlexRow
                gray
                gap="50px"
                padding="2vh 3vw 2vh 3vw"
                gapMd="20px"
              >
                <ContainerFlexColumnStart center>
                  <CustomSubtitle
                    bold
                    size="22px"
                    dangerouslySetInnerHTML={{
                      __html:
                        'Match 2 : Places I have visited / Places I have visited:',
                    }}
                  ></CustomSubtitle>
                  <CustomSubtitle
                    size="20px"
                    dangerouslySetInnerHTML={{
                      __html: `No. of matches = ${
                        result['data']['match2'] !== null
                          ? Object.keys(result['data']['match2']).length
                          : 0
                      }:`,
                    }}
                  ></CustomSubtitle>
                </ContainerFlexColumnStart>
              </ContainerFlexRow>
              <ContainerFlexRow
                gray
                gap="50px"
                padding="2vh 3vw 2vh 3vw"
                gapMd="20px"
              >
                <ContainerFlexColumnStart center>
                  <CustomSubtitle
                    bold
                    size="22px"
                    dangerouslySetInnerHTML={{
                      __html:
                        'Match 3 : Places I want to visit / Member location (by Country):',
                    }}
                  ></CustomSubtitle>
                  <CustomSubtitle
                    size="20px"
                    dangerouslySetInnerHTML={{
                      __html: `No. of matches = ${
                        result['data']['match3'] !== null
                          ? Object.keys(result['data']['match3']).length
                          : 0
                      }:`,
                    }}
                  ></CustomSubtitle>
                </ContainerFlexColumnStart>
              </ContainerFlexRow>
              <ContainerFlexRow
                gray
                gap="50px"
                padding="2vh 3vw 2vh 3vw"
                gapMd="20px"
              >
                <ContainerFlexColumnStart center>
                  <CustomSubtitle
                    bold
                    size="22px"
                    dangerouslySetInnerHTML={{
                      __html:
                        'Match 4 : Places I have visited / Member location (by Country):',
                    }}
                  ></CustomSubtitle>
                  <CustomSubtitle
                    size="20px"
                    dangerouslySetInnerHTML={{
                      __html: `No. of matches = ${
                        result['data']['match4'] !== null
                          ? Object.keys(result['data']['match4']).length
                          : 0
                      }:`,
                    }}
                  ></CustomSubtitle>
                </ContainerFlexColumnStart>
              </ContainerFlexRow>
              <ContainerFlexRow
                gray
                gap="50px"
                padding="2vh 3vw 2vh 3vw"
                gapMd="20px"
              >
                <ContainerFlexColumnStart center>
                  <CustomSubtitle
                    bold
                    size="22px"
                    dangerouslySetInnerHTML={{
                      __html:
                        'Match 5 : Places I want to visit / Member location (by City):',
                    }}
                  ></CustomSubtitle>
                  <CustomSubtitle
                    size="20px"
                    dangerouslySetInnerHTML={{
                      __html: `No. of matches = ${
                        result['data']['match5'] !== null
                          ? Object.keys(result['data']['match5']).length
                          : 0
                      }:`,
                    }}
                  ></CustomSubtitle>
                </ContainerFlexColumnStart>
              </ContainerFlexRow>
              <ContainerFlexRow
                gray
                gap="50px"
                padding="2vh 3vw 2vh 3vw"
                gapMd="20px"
              >
                <ContainerFlexColumnStart center>
                  <CustomSubtitle
                    bold
                    size="22px"
                    dangerouslySetInnerHTML={{
                      __html:
                        'Match 6 : Places I have visited / Member location (by City):',
                    }}
                  ></CustomSubtitle>
                  <CustomSubtitle
                    size="20px"
                    dangerouslySetInnerHTML={{
                      __html: `No. of matches = ${
                        result['data']['match6'] !== null
                          ? Object.keys(result['data']['match6']).length
                          : 0
                      }:`,
                    }}
                  ></CustomSubtitle>
                </ContainerFlexColumnStart>
              </ContainerFlexRow>
              <ContainerFlexRow
                gray
                gap="50px"
                padding="2vh 3vw 2vh 3vw"
                gapMd="20px"
              >
                <ContainerFlexColumnStart center>
                  <CustomSubtitle
                    bold
                    size="22px"
                    dangerouslySetInnerHTML={{
                      __html: 'Match 7 : Interests / Interests:',
                    }}
                  ></CustomSubtitle>
                  <CustomSubtitle
                    size="20px"
                    dangerouslySetInnerHTML={{
                      __html: `No. of matches = ${
                        result['data']['match7'] !== null
                          ? Object.keys(result['data']['match7']).length
                          : 0
                      }:`,
                    }}
                  ></CustomSubtitle>
                </ContainerFlexColumnStart>
              </ContainerFlexRow>
              <ContainerFlexRow
                gray
                gap="50px"
                padding="2vh 3vw 2vh 3vw"
                gapMd="20px"
              >
                <ContainerFlexColumnStart center>
                  <CustomSubtitle
                    bold
                    size="22px"
                    dangerouslySetInnerHTML={{
                      __html:
                        'Match 8 : Places I want to visit / Places I have visited:',
                    }}
                  ></CustomSubtitle>
                  <CustomSubtitle
                    size="20px"
                    dangerouslySetInnerHTML={{
                      __html: `No. of matches = ${
                        result['data']['match8'] !== null
                          ? Object.keys(result['data']['match8']).length
                          : 0
                      }:`,
                    }}
                  ></CustomSubtitle>
                </ContainerFlexColumnStart>
              </ContainerFlexRow>
            </Section>
          ) : (
            <Section>
              <FlexRow>No matches found for this member.</FlexRow>
            </Section>
          )}

          {result['data']['match1'] !== null &&
            result['data']['match1'].map((item, index) => {
              {
                console.log('match1 index: ' + index)
              }
              return (
                <ResultPanel
                  content={item}
                  panelHeader={
                    index == 0
                      ? `Match 1 : Places I want to visit / Places I want to visit<br/>No. of matches = ${
                          Object.keys(result['data']['match1']).length
                        }:`
                      : ''
                  }
                  index={index}
                  total={Object.keys(result['data']['match1']).length}
                  matchArr={result['data']['placesWanted']}
                  matchType="wanted"
                />
              )
            })}
          {result['data']['match2'] !== null &&
            result['data']['match2'].map((item, index) => {
              {
                console.log('match2 index: ' + index)
              }
              return (
                <ResultPanel
                  content={item}
                  panelHeader={
                    index == 0
                      ? `Match 2 : Places I have visited / Places I have visited<br/>No. of matches = ${
                          Object.keys(result['data']['match2']).length
                        }:`
                      : ''
                  }
                  index={index}
                  total={Object.keys(result['data']['match2']).length}
                  matchArr={result['data']['placesVisited']}
                  matchType="visited"
                />
              )
            })}
          {result['data']['match3'] !== null &&
            result['data']['match3'].map((item, index) => {
              {
                console.log('match3 index: ' + index)
              }
              return (
                <ResultPanel
                  content={item}
                  panelHeader={
                    index == 0
                      ? `Match 3 : Places I want to visit / Member location (Country)<br/>No. of matches = ${
                          Object.keys(result['data']['match3']).length
                        }:`
                      : ''
                  }
                  index={index}
                  total={Object.keys(result['data']['match3']).length}
                  matchArr={result['data']['placesWanted']}
                  matchType="location"
                />
              )
            })}
          {result['data']['match4'] !== null &&
            result['data']['match4'].map((item, index) => {
              {
                console.log('match4 index: ' + index)
              }
              return (
                <ResultPanel
                  content={item}
                  panelHeader={
                    index == 0
                      ? `Match 4 : Places I have visited / Member location (Country)<br/>No. of matches = ${
                          Object.keys(result['data']['match4']).length
                        }:`
                      : ''
                  }
                  index={index}
                  total={Object.keys(result['data']['match4']).length}
                  matchArr={result['data']['placesVisited']}
                  matchType="location"
                />
              )
            })}
          {result['data']['match5'] !== null &&
            result['data']['match5'].map((item, index) => {
              {
                console.log('match5 index: ' + index)
              }
              return (
                <ResultPanel
                  content={item}
                  panelHeader={
                    index == 0
                      ? `Match 5 : Places I want to visit / Member location (City)<br/>No. of matches = ${
                          Object.keys(result['data']['match5']).length
                        }:`
                      : ''
                  }
                  index={index}
                  total={Object.keys(result['data']['match5']).length}
                  matchArr={result['data']['placesWanted']}
                  matchType="location"
                />
              )
            })}
          {result['data']['match6'] !== null &&
            result['data']['match6'].map((item, index) => {
              {
                console.log('match6 index: ' + index)
              }
              return (
                <ResultPanel
                  content={item}
                  panelHeader={
                    index == 0
                      ? `Match 6 : Places I have visited / Member location (City)<br/>No. of matches = ${
                          Object.keys(result['data']['match6']).length
                        }:`
                      : ''
                  }
                  index={index}
                  total={Object.keys(result['data']['match6']).length}
                  matchArr={result['data']['placesVisited']}
                  matchType="location"
                />
              )
            })}
          {result['data']['match7'] !== null &&
            result['data']['match7'].map((item, index) => {
              {
                console.log('match7 index: ' + index)
              }
              return (
                <ResultPanel
                  content={item}
                  panelHeader={
                    index == 0
                      ? `Match 7 : Interests / Interests<br/>No. of matches = ${
                          Object.keys(result['data']['match7']).length
                        }:`
                      : ''
                  }
                  index={index}
                  total={Object.keys(result['data']['match7']).length}
                  matchArr={result['data']['interests']}
                  matchType="interests"
                />
              )
            })}
          {result['data']['match8'] !== null &&
            result['data']['match8'].map((item, index) => {
              {
                console.log('match8 index: ' + index)
              }
              return (
                <ResultPanel
                  content={item}
                  panelHeader={
                    index == 0
                      ? `Match 8 : Places I want to visit / Places I have visited<br/>No. of matches = ${
                          Object.keys(result['data']['match8']).length
                        }:`
                      : ''
                  }
                  index={index}
                  total={Object.keys(result['data']['match8']).length}
                  matchArr={result['data']['placesWanted']}
                  matchType="visited"
                />
              )
            })}
        </>
      )}
    </Container>
  )
}

export default MemberMatchTest
